import { ICancellationToken } from '../contracts/cancellation/cancellation-token';
import { errorMessageOf } from '../logging/error-normalization';
import { ObservableModel } from '../viewmodel/observable-model';

export class CancellationToken implements ICancellationToken {
  public promise: Promise<void>;
  public cancelled: ObservableModel<boolean>;
  // Retry counter per service while it is being retried (see ICancellationToken.serviceRepeats).
  public serviceRepeats?: Record<string, number> = {};
  // Per service: synced ALL data successfully - drives attachment ordering + completedData, NOT the
  // indicator close (see ICancellationToken.syncCompleted).
  public syncCompleted?: Record<string, boolean> = {};
  // Per service: reached any terminal state (success/error/cancel/ignored) - drives the sync
  // indicator close (see ICancellationToken.syncTerminal).
  public syncTerminal?: Record<string, boolean> = {};

  constructor() {
    this.cancelled = new ObservableModel(false, false);
  }

  public async cancel(): Promise<void> {
    this.cancelled.set(true);
    if (this.promise && this.promise.then) {
      // A rejection means the tracked process already died — its error is logged at its
      // origin. cancel() only guarantees "the process has stopped", so the rejection must
      // not propagate: it used to abort the TokenHandler step on every following sync run
      // and thereby blocked syncing until an app restart (work item 27022).
      await this.promise.then(
        () => undefined,
        error =>
          window.logger?.addBreadcrumb({
            message: `[CancellationToken] cancelled process had already failed: ${errorMessageOf(error)}`,
          })
      );
    }
  }

  public reset(): ICancellationToken {
    this.cancelled = new ObservableModel(false, false);
    this.promise = undefined;

    return this;
  }
}
